export type AreaUnit = 'Sqft' | 'Sqm';
export const AreaUnit = {
  Sqft: 'Sqft',
  Sqm: 'Sqm',
} as const;

export type BoardResolutionMode = 'ANY_ONE_TO_SIGN' | 'ANY_TWO_TO_SIGN';
export const BoardResolutionMode: Record<BoardResolutionMode, BoardResolutionMode> = {
  ANY_ONE_TO_SIGN: 'ANY_ONE_TO_SIGN',
  ANY_TWO_TO_SIGN: 'ANY_TWO_TO_SIGN',
} as const;

export type BusinessConstitution = 'SOLE_PROPRIETOR' | 'PARTNER' | 'NOT_APPLICABLE';
export const BusinessConstitution: Record<BusinessConstitution, BusinessConstitution> = {
  SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
  PARTNER: 'PARTNER',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export type BusinessOwnership =
  | 'INDIVIDUAL_SHAREHOLDERS'
  | 'CORPORATE_ENTITY_SHAREHOLDERS'
  | 'BOTH_INDIVIDUAL_AND_CORPORATE_ENTITY_SHAREHOLDERS'
  | 'NOT_APPLICABLE';
export const BusinessOwnership: Record<BusinessOwnership, BusinessOwnership> = {
  INDIVIDUAL_SHAREHOLDERS: 'INDIVIDUAL_SHAREHOLDERS',
  CORPORATE_ENTITY_SHAREHOLDERS: 'CORPORATE_ENTITY_SHAREHOLDERS',
  BOTH_INDIVIDUAL_AND_CORPORATE_ENTITY_SHAREHOLDERS: 'BOTH_INDIVIDUAL_AND_CORPORATE_ENTITY_SHAREHOLDERS',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
} as const;

export type CaseAttachmentKey =
  | 'NRIC'
  | 'BANK_STATEMENTS'
  | 'FINANCIAL_STATEMENTS'
  | 'PROOF_OF_PROPERTY_OWNERSHIP'
  | 'PURCHASE_AGREEMENT'
  | 'BOARD_RESOLUTION'
  | 'HISTORY_NAME_AND_UEN'
  | 'APPOINTMENTS'
  | 'SHAREHOLDERS'
  | 'OTHER'
  | 'CREDIT_EXPOSURE'
  | 'TOTAL_GROUP_EXPOSURE';
export const CaseAttachmentKey: Record<CaseAttachmentKey, CaseAttachmentKey> = {
  APPOINTMENTS: 'APPOINTMENTS',
  BANK_STATEMENTS: 'BANK_STATEMENTS',
  BOARD_RESOLUTION: 'BOARD_RESOLUTION',
  CREDIT_EXPOSURE: 'CREDIT_EXPOSURE',
  FINANCIAL_STATEMENTS: 'FINANCIAL_STATEMENTS',
  HISTORY_NAME_AND_UEN: 'HISTORY_NAME_AND_UEN',
  NRIC: 'NRIC',
  OTHER: 'OTHER',
  PROOF_OF_PROPERTY_OWNERSHIP: 'PROOF_OF_PROPERTY_OWNERSHIP',
  PURCHASE_AGREEMENT: 'PURCHASE_AGREEMENT',
  SHAREHOLDERS: 'SHAREHOLDERS',
  TOTAL_GROUP_EXPOSURE: 'TOTAL_GROUP_EXPOSURE',
} as const;

export type CollateralPropertyType = 'COMMERCIAL' | 'INDUSTRIAL' | 'RESIDENTIAL';
export const CollateralPropertyType: Record<CollateralPropertyType, CollateralPropertyType> = {
  COMMERCIAL: 'COMMERCIAL',
  INDUSTRIAL: 'INDUSTRIAL',
  RESIDENTIAL: 'RESIDENTIAL',
} as const;

export type CollateralPropertyCompletionStatus =
  | 'COMPLETED'
  | 'COMPLETED_PENDING_CSC'
  | 'COMPLETED_PROGRESSIVE_DISBURSEMENT'
  | 'BUILDING_UNDER_CONSTRUCTION';
export const CollateralPropertyCompletionStatus: Record<
  CollateralPropertyCompletionStatus,
  CollateralPropertyCompletionStatus
> = {
  COMPLETED: 'COMPLETED',
  COMPLETED_PENDING_CSC: 'COMPLETED_PENDING_CSC',
  COMPLETED_PROGRESSIVE_DISBURSEMENT: 'COMPLETED_PROGRESSIVE_DISBURSEMENT',
  BUILDING_UNDER_CONSTRUCTION: 'BUILDING_UNDER_CONSTRUCTION',
} as const;

export type CollateralPropertyUsage = 'RENTAL_SAVINGS' | 'RENTAL_INCOME';
export const CollateralPropertyUsage: Record<CollateralPropertyUsage, CollateralPropertyUsage> = {
  RENTAL_SAVINGS: 'RENTAL_SAVINGS',
  RENTAL_INCOME: 'RENTAL_INCOME',
} as const;

export type CollateralPropertyTenure = 'FREEHOLD' | 'LEASEHOLD';
export const CollateralPropertyTenure: Record<CollateralPropertyTenure, CollateralPropertyTenure> = {
  FREEHOLD: 'FREEHOLD',
  LEASEHOLD: 'LEASEHOLD',
} as const;

export type MinimumAmountReceiveNotification = 'ANY' | 'S$1000' | 'S$5000' | 'S$10000000';
export const MinimumAmountReceiveNotification = {
  ANY: 'ANY',
  S$1000: 'S$1000',
  S$5000: 'S$5000',
  S$10000000: 'S$10000000',
};

export type PeriodUnit = 'MONTHS' | 'YEAR';
export const PeriodUnit: Record<PeriodUnit, PeriodUnit> = {
  MONTHS: 'MONTHS',
  YEAR: 'YEAR',
} as const;

export type PersonnelAppointment =
  | 'KEYMAN'
  | 'AUTHORISED_SIGNATORY'
  | 'SHAREHOLDER'
  | 'DIRECTOR'
  | 'GUARANTOR'
  | 'SECRETARY';
export const PersonnelAppointment: Record<PersonnelAppointment, PersonnelAppointment> = {
  KEYMAN: 'KEYMAN',
  AUTHORISED_SIGNATORY: 'AUTHORISED_SIGNATORY',
  SHAREHOLDER: 'SHAREHOLDER',
  DIRECTOR: 'DIRECTOR',
  GUARANTOR: 'GUARANTOR',
  SECRETARY: 'SECRETARY',
} as const;

export type PersonnelAttachmentKey = 'CPF' | 'SIGNATURE' | 'NOTICE_OF_ASSESSMENT';
export const PersonnelAttachmentKey: Record<PersonnelAttachmentKey, PersonnelAttachmentKey> = {
  CPF: 'CPF',
  SIGNATURE: 'SIGNATURE',
  NOTICE_OF_ASSESSMENT: 'NOTICE_OF_ASSESSMENT',
} as const;

export type PersonnelAttachmentSection = 'CBS' | 'GENERAL';
export const PersonnelAttachmentSection: Record<PersonnelAttachmentSection, PersonnelAttachmentSection> = {
  CBS: 'CBS',
  GENERAL: 'GENERAL',
} as const;

export type PersonnelConfirmStatus = 'pending' | 'processing' | 'confirmed';
export const PersonnelConfirmStatus: Record<PersonnelConfirmStatus, PersonnelConfirmStatus> = {
  pending: 'pending',
  processing: 'processing',
  confirmed: 'confirmed',
} as const;

export type PersonnelGender = 'MALE' | 'FEMALE' | 'UNKNOWN';
export const PersonnelGender: Record<PersonnelGender, PersonnelGender> = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  UNKNOWN: 'UNKNOWN',
} as const;

export type PersonnelMarital = 'SINGLE' | 'MARRIED' | 'WIDOWED' | 'DIVORCED';
export const PersonnelMarital: Record<PersonnelMarital, PersonnelMarital> = {
  SINGLE: 'SINGLE',
  MARRIED: 'MARRIED',
  WIDOWED: 'WIDOWED',
  DIVORCED: 'DIVORCED',
} as const;

export type PersonnelOwnership = 'OWNED_FULLY_PAID' | 'OWNED_MORTGAGED' | 'PARENT_HOUSE' | 'RENTED' | 'OTHER';
export const PersonnelOwnership: Record<PersonnelOwnership, PersonnelOwnership> = {
  OWNED_FULLY_PAID: 'OWNED_FULLY_PAID',
  OWNED_MORTGAGED: 'OWNED_MORTGAGED',
  PARENT_HOUSE: 'PARENT_HOUSE',
  RENTED: 'RENTED',
  OTHER: 'OTHER',
} as const;

export type PersonnelRace = 'CHINESE' | 'MALAY' | 'INDIAN' | 'EURASIAN' | 'OTHER';
export const PersonnelRace: Record<PersonnelRace, PersonnelRace> = {
  CHINESE: 'CHINESE',
  MALAY: 'MALAY',
  INDIAN: 'INDIAN',
  EURASIAN: 'EURASIAN',
  OTHER: 'OTHER',
} as const;

export type PersonnelResidence = 'LANDED' | 'PRIVATE_APARTMENT_OR_CONDOMINIUM' | 'EXECUTIVE_CONDO_OR_HUDC' | 'HDB';
export const PersonnelResidence: Record<PersonnelResidence, PersonnelResidence> = {
  LANDED: 'LANDED',
  PRIVATE_APARTMENT_OR_CONDOMINIUM: 'PRIVATE_APARTMENT_OR_CONDOMINIUM',
  EXECUTIVE_CONDO_OR_HUDC: 'EXECUTIVE_CONDO_OR_HUDC',
  HDB: 'HDB',
} as const;

export type PersonnelRelationship = 'DIRECTOR' | 'PARTNER' | 'SOLE_PROPRIETOR' | 'SHAREHOLDER' | 'SECRETARY' | 'OTHER';
export const PersonnelRelationship: Record<PersonnelRelationship, PersonnelRelationship> = {
  DIRECTOR: 'DIRECTOR',
  PARTNER: 'PARTNER',
  SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
  SHAREHOLDER: 'SHAREHOLDER',
  SECRETARY: 'SECRETARY',
  OTHER: 'OTHER',
} as const;

export type PersonnelResidency =
  | 'CITIZEN'
  | 'PERMANENT_RESIDENT'
  | 'FOREIGNER'
  | 'ALIEN'
  | 'UNKNOWN'
  | 'NOT_APPLICABLE';
export const PersonnelResidency: Record<PersonnelResidency, PersonnelResidency> = {
  CITIZEN: 'CITIZEN',
  PERMANENT_RESIDENT: 'PERMANENT_RESIDENT',
  FOREIGNER: 'FOREIGNER',
  ALIEN: 'ALIEN',
  UNKNOWN: 'UNKNOWN',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
} as const;

export type PersonnelType = 'entity' | 'individual';
export const PersonnelType: Record<PersonnelType, PersonnelType> = {
  entity: 'entity',
  individual: 'individual',
} as const;

export type ProductProgram =
  | 'BIZ_PROP'
  | 'BIZ_PROP_I'
  | 'BIZ_PROP_PLUS'
  | 'BIZ_PROP_PLUS_I'
  | 'BIZ_GROW'
  | 'BIZ_GROW_I'
  | 'BIZ_GROW_ESG'
  | 'BIZ_GROW_ESG_I'
  | 'BIZ_ASSURE'
  | 'BIZ_ASSURE_I';
export const ProductProgram: Record<ProductProgram, ProductProgram> = {
  BIZ_PROP: 'BIZ_PROP',
  BIZ_PROP_I: 'BIZ_PROP_I',
  BIZ_PROP_PLUS: 'BIZ_PROP_PLUS',
  BIZ_PROP_PLUS_I: 'BIZ_PROP_PLUS_I',
  BIZ_GROW: 'BIZ_GROW',
  BIZ_GROW_I: 'BIZ_GROW_I',
  BIZ_GROW_ESG: 'BIZ_GROW_ESG',
  BIZ_GROW_ESG_I: 'BIZ_GROW_ESG_I',
  BIZ_ASSURE: 'BIZ_ASSURE',
  BIZ_ASSURE_I: 'BIZ_ASSURE_I',
};

export type LeadAttachmentKey = 'BANK_STATEMENT';
export const LeadAttachmentKey: Record<LeadAttachmentKey, LeadAttachmentKey> = {
  BANK_STATEMENT: 'BANK_STATEMENT',
} as const;
